var SortDirections;
(function (SortDirections) {
    SortDirections["ASCENDING"] = "";
    SortDirections["DESCENDING"] = "-";
})(SortDirections || (SortDirections = {}));
export default SortDirections;
